import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import firebase from 'firebase';

@Injectable()
export class LoginServiceProvider {

  constructor(public http: Http) {
    console.log('Hello AuthserviceProvider Provider');
  }

  // user login
  userLogin(emai: string, password: string) {
    return firebase.auth().signInWithEmailAndPassword(emai, password);
  }

  // user register
  userRegistration(email: string, password: string) {
    return firebase.auth().createUserWithEmailAndPassword(email, password);
  }

  // Reset Password
  resetPassword(email:string){
    return firebase.auth().sendPasswordResetEmail(email);
  }

  logOut() {
    firebase.auth().signOut();
  }

  // get current user id
  getUserId() {
    return firebase.auth().currentUser;
  }
  // gerDatabase name

}



// WEBPACK FOOTER //
// ./src/providers/authservice/loginService.ts